import { Filter } from "./filter";

export class ByAssigned extends Filter {
  constructor(public id?: number) {
    super("by.assigned");
  }
}
